export const types = {
    ADD_NEW_ACTION_TO_HISTORY: 'add_new_action_to_history',
    UNDO: 'undo',
    REDO: 'redo'
};

export function addNewActionToHistory() {
    return { type: types.ADD_NEW_ACTION_TO_HISTORY};
}

export function undo() {
    return { type: types.UNDO};
}

export function redo() {
    return { type: types.REDO};
}



/** WEBPACK FOOTER **
 ** ./src/actions/UndoRedoActions.js
 **/